import fileDownload from 'js-file-download';
import { FILE_TYPES } from '../constants';
import { base64toBytes } from './base-64-to-bytes';
export var downloadFile = function (_a) {
    var fileType = _a.fileType, file = _a.file, contentType = _a.contentType, name = _a.name;
    // get file
    var blobFile = fileType === FILE_TYPES.base64 ? base64toBytes(file, contentType) : file;
    // download file
    fileDownload(blobFile, name);
};
